import { STATIC_IMAGES_HOST } from '@constants/env';

export enum StoragePath {
  ProfileAvatar = 'profile',
  AppLogo = 'apps',
}

export const getStaticHostURL = (imageSrc: string, path: StoragePath): string =>
  `${STATIC_IMAGES_HOST}/${path}/${imageSrc}`;
